var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderProfile',{attrs:{"img_header":_vm.header_image,"header":"จัดการข้อมูลส่วนตัว"}}),_c('ProfileView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }